import * as React from 'react';
import { EntityConfig, entityStandardFormFields } from '@shapeable/core';
import { TransplantLifeStage as MyType } from '@shapeable/kelp-forest-alliance-types';
const gql = String.raw;

export const TransplantLifeStage: EntityConfig<MyType> = {
  name: 'TransplantLifeStage',
  type: 'taxonomy',
  icon: ({ icons }) => icons.Entities.Target,
  autoRoutes: ['list', 'create', 'update'],
  form: {
    fields: {
      ...entityStandardFormFields,
      description: { type: 'longText' },
    }
  }
};